import QueryContext from '../QueryContext';
import api from '../index';

const contentAgreementTermFetchers = {
  contentAgreementTerms: (context?: QueryContext) =>
    api.get('/content_agreement_terms', {}),
};

export default contentAgreementTermFetchers;
